

export function checkRegistrationForErrors(){
    let error = false;
    const re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    const items = {
        email: $("#reg-email"),
        password: $("#reg-password"),
        check: $("#password-check"),
        vorname: $("#reg-vorname"),
        nachname: $("#reg-nachname"),
        rights: $("#checkbox-signup"),
    }

    const email = items.email.val().toString();
    const is_email = re.test(email);
    if ( is_email ){
        items.email.removeClass("is-invalid").addClass("is-valid");
    } else {
        items.email.removeClass("is-valid").addClass("is-invalid");
        items.email.next().next().html("Bitte geben Sie eine gültige E-Mail-Adresse an").show();
        error = true;
    }
    const password = items.password.val().toString();
    if (password.length < 6){
        items.password.removeClass("is-valid").addClass("is-invalid");
        items.password.next().next().html("Dein Passwort ist zu kurz!").show();
    } else {
        items.password.removeClass("is-invalid").addClass("is-valid");
    }
    const check = items.check.val();
    if ( password != check || password.length < 6 ){
        items.check.removeClass("is-valid").addClass("is-invalid");
        items.check.next().next().html("Passwörter stimmen nicht überein").show();
        error = true;
    }
    const vorname = items.vorname.val();
    const nachname = items.nachname.val();
    if (vorname == ''){
        items.vorname.removeClass("is-valid").addClass("is-invalid");
        items.vorname.next().next().html("Bitte geben Sie ihren Vornamen an").show();
        error = true;
    } else {
        items.vorname.removeClass("is-invalid").addClass("is-valid");
    }
    if (nachname == ''){
        items.nachname.removeClass("is-valid").addClass("is-invalid");
        items.nachname.next().next().html("Bitte geben Sie ihren Nachnamen an").show();
        error = true;
    } else {
        items.nachname.removeClass("is-invalid").addClass("is-valid");
    }
    if (!items.rights.is(":checked")){
        error = true;
        items.rights.addClass("is-invalid");
        items.rights.parent().addClass("has-danger");
    }
    return {
        errors: error,
        email: email,
        nachname: nachname,
        vorname: vorname,
        password: password,
    };
}